import { Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';

const EmptyPlaceholder = (props: any): ReactElement => {
  const { icon, title, message } = props;
  return (
    <Stack
      className="empty-content"
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      {icon}
      <Stack mt={5} spacing={4} className="empty-text" alignItems="center">
        <Typography className="text-gray" variant="h6">
          {title}
        </Typography>
        <Typography className="text-gray">{message}</Typography>
      </Stack>
    </Stack>
  );
};

export default EmptyPlaceholder;
